<template>
  <a href="#" class="hamburger-container">
    <input id="ham-check" type="checkbox" />
    <div id="hamburger-row"></div>
  </a>
</template>

<script>
export default {
  name: "Hamburger",
};
</script>

<style scoped>
.hamburger-container {
  background: transparent;
  min-width: 2em;
  width: 3em;
  max-width: 5em;
  cursor: pointer;
  position: relative;
  margin: 0.5em;
  margin-inline-end: 1.5em;
  overflow: hidden;
}

#hamburger-row {
  position: absolute;
  width: 2.2em;
  height: 0.4em;
  background: var(--dark-clr);
  border-radius: 2em;
  left: calc(50% - 1.1em);
  top: calc(50% - 0.25em);
  overflow: visible;
  transition: var(--transition);
}

.hamburger-container:hover > #hamburger-row,
.hamburger-container:focus > #hamburger-row {
  background: var(--primary-clr);
}

#hamburger-row::before,
#hamburger-row::after {
  content: "";
  position: absolute;
  width: 2em;
  height: 0.4em;
  background: inherit;
  border-radius: 2em;
  left: calc(50% - 1em);
  transition: var(--transition);
  background: var(--dark-clr);
}

.hamburger-container:hover > #hamburger-row::before,
.hamburger-container:focus > #hamburger-row::before,
.hamburger-container:hover > #hamburger-row::after,
.hamburger-container:focus > #hamburger-row::after {
  background: var(--mid-dark-clr);
}

#hamburger-row::before {
  top: -150%;
}
#hamburger-row::after {
  top: 150%;
}

#ham-check {
  display: none;
}

#ham-check:checked + #hamburger-row {
  width: 0;
  left: 50%;
}

#ham-check:checked + #hamburger-row::before {
  top: calc(50% - 0.25em);
  transform: rotateZ(-45deg);
}

#ham-check:checked + #hamburger-row::after {
  transform: rotateZ(45deg);
  top: calc(50% - 0.25em);
}
</style>
